import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleSection() {
  const displayedArticles = articles.slice(0, 6);

  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-14 gap-4">
          <div>
            <p className="font-heading text-sm uppercase tracking-[0.2em] text-accent-600 mb-3">Superbuy Guides</p>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900">
              Latest <span className="italic text-primary-600">Spreadsheet Resources</span>
            </h2>
          </div>
          <p className="text-foreground-600 text-sm md:text-base max-w-md">
            Expert-written guides covering everything from beginner tutorials to advanced shopping strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {displayedArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden cursor-pointer hover:bg-background-200/50 transition-colors duration-300"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs font-medium px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200 leading-snug">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2">{article.excerpt}</p>
                <div className="flex items-center gap-1 mt-4 text-primary-600 text-sm font-medium">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/article/what-is-superbuy-spreadsheet"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-900 text-white font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-all duration-300"
          >
            View All Guides
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}